/**
 * Type-guarded null/undefined check.
 *
 * Returns true when the value is `null` or `undefined`, and narrows the
 * type accordingly in conditional branches so TypeScript can infer
 * non-nullable types without manual assertions.
 *
 * Internally uses non-strict equality (`== null`) which is intentional:
 * `value == null` is the only idiomatic use of non-strict comparison in
 * JavaScript — it matches both `null` and `undefined` in a single check
 * without matching other falsy values like `0`, `""`, or `false`.
 * Wrapping it in a named function makes the intent explicit and prevents
 * it from being mistakenly "fixed" to strict equality during refactoring,
 * which would silently break the undefined half of the check.
 */
export function isNil(value: unknown): value is null | undefined {
  return value == null
}
